<script>
	import { createEventDispatcher } from "svelte";
	export let tracker;
	export let target;
	export let options;

	let distance;

	const dispatch = createEventDispatcher();

	// console.log(target, options);

	function error(err) {
		console.error(`ERROR(${err.code}): ${err.message}`);
		dispatch("error", { code: err.code, message: err.message });
	}

	function success(pos) {
		const crd = pos.coords;

		// console.log(crd);
		distance = calcDistance(
			crd.latitude,
			crd.longitude,
			target.latitude,
			target.longitude,
			"K"
		);
		dispatch("distance", distance);
		// console.log(distance);
		// if (
		// 	target.latitude === crd.latitude &&
		// 	target.longitude === crd.longitude
		// ) {
		// 	console.log("Congratulations, you reached the target");
		// 	navigator.geolocation.clearWatch(tracker);
		// }
	}

	// function setTracker() {
	if (navigator.geolocation) {
		tracker = navigator.geolocation.watchPosition(success, error, options);
	} else {
		dispatch("error", {
			code: "BROWSER",
			message: "Geolocation is not supported by this browser.",
		});
		// x.innerHTML = "Geolocation is not supported by this browser.";
	}

	function calcDistance(lat1, lon1, lat2, lon2, unit) {
		if (lat1 == lat2 && lon1 == lon2) {
			return 0;
		} else {
			var radlat1 = (Math.PI * lat1) / 180;
			var radlat2 = (Math.PI * lat2) / 180;
			var theta = lon1 - lon2;
			var radtheta = (Math.PI * theta) / 180;
			var dist =
				Math.sin(radlat1) * Math.sin(radlat2) +
				Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = (dist * 180) / Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit == "K") {
				dist = dist * 1.609344;
			}
			if (unit == "N") {
				dist = dist * 0.8684;
			}
			return dist;
		}
	}
	// }
</script>
